import PrivateRoute from './PrivateRoute.jsx'

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/components/PrivateRoute/index.js